import "../styles/error_screen.scss"
function ErrorScreen() {
    return <div className={'error-screen'}>
        <header>
            <h1>Hoppla!</h1>
        </header>
        <p>Die gewünschte Seite konnte nicht gefunden werden.</p>
    </div>;
}

export default ErrorScreen;